import { apiCall } from './gqlClient';
const GETGROUPS_QUERY = "\n  query getGroups($type: String!) {\n    getGroups(type: $type)\n    {\n      id\n\t\t\tproviderId\n\t\t\tname\n\t\t\tcolor\n\t\t\tcounter\n\t\t\ttype\n      ...fragments\n    }\n  }";
export const getGroupsApiCall = async function (_ref) {
  let {
    type
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETGROUPS_QUERY,
    variables: {
      type
    },
    fragments
  });
};
const GETALLPROVIDERGROUPS_QUERY = "\n  query getAllProviderGroups {\n    getAllProviderGroups\n    {\n      id\n\t\t\tproviderId\n\t\t\tname\n\t\t\tcolor\n\t\t\tcounter\n\t\t\ttype\n      ...fragments\n    }\n  }";
export const getAllProviderGroupsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETALLPROVIDERGROUPS_QUERY,
    variables: {},
    fragments
  });
};
const SAVEGROUP_QUERY = "\n  mutation saveGroup($name: String!, $type: String!, $color: String!, $id: Int) {\n    saveGroup(name: $name, type: $type, color: $color, id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveGroupApiCall = async function (_ref2) {
  let {
    name,
    type,
    color,
    id
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEGROUP_QUERY,
    variables: {
      name,
      type,
      color,
      id
    },
    fragments
  });
};
const DELETEGROUP_QUERY = "\n  mutation deleteGroup($id: Int!, $type: String) {\n    deleteGroup(id: $id, type: $type)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const deleteGroupApiCall = async function (_ref3) {
  let {
    id,
    type
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEGROUP_QUERY,
    variables: {
      id,
      type
    },
    fragments
  });
};